/**
 * Sanitize filename for presign API and S3.
 * Matches backend rules: alphanumeric, dash, underscore, dot; max 200 chars.
 * Preserves extension; replaces spaces with underscores; removes unsafe chars.
 */
const MAX_FILENAME_LEN = 200;
const SAFE_CHAR_REGEX = /[a-zA-Z0-9._-]/g;

export function sanitizeFilename(name: string): string {
  if (!name || typeof name !== 'string') return 'document';
  // Take basename only (no path)
  let base = name.replace(/\\/g, '/').split('/').pop()?.trim() ?? '';
  if (!base) return 'document';

  const lastDot = base.lastIndexOf('.');
  const hasExtension = lastDot > 0 && lastDot < base.length - 1;
  const stem = hasExtension ? base.slice(0, lastDot) : base;
  const ext = hasExtension ? base.slice(lastDot) : '';

  // Replace spaces with underscores, then keep only safe chars
  let safeStem = stem.replace(/\s+/g, '_');
  safeStem = (safeStem.match(SAFE_CHAR_REGEX) || []).join('');
  // Collapse multiple underscores
  safeStem = safeStem.replace(/_+/g, '_').replace(/^_|_$/g, '') || 'document';
  // Sanitize extension (only safe chars; ext includes leading dot)
  const safeExt = ext ? (ext.match(SAFE_CHAR_REGEX) || []).join('') : '';

  let result = safeExt ? safeStem + safeExt : safeStem;
  if (result.length > MAX_FILENAME_LEN) {
    const extLen = safeExt.length;
    result = result.slice(0, MAX_FILENAME_LEN - extLen) + safeExt;
  }
  return result || 'document';
}
